import React from 'react';
import { Activity } from '@bingads-webui-react/hoc-with-signal';
import { STEP_PATHS, FLOWS } from './step-constants';
import { AssetsStepShell, useAssetStepRepository } from './assets';
import { BudgetStepShell, useBudgetStepRepository } from './budget';
import { TargetingStepShell, useTargetingStepRepository } from './targeting';
import { ProductsStepShell, useProductsStepRepository } from './products';
import { CampaignDetailsStepShell, useCampaignDetailsStepRepository } from './campaign-details';
import { SummaryStepShell, useSummaryStepRepository } from './summary';

export const StepConfig = [{
  id: STEP_PATHS.ASSETS,
  view: props => <Activity name={STEP_PATHS.ASSETS}> <AssetsStepShell {...props} /> </Activity>,
  repository: useAssetStepRepository,
},
{
  id: STEP_PATHS.PRODUCTS,
  view: props => <Activity name={STEP_PATHS.PRODUCTS}> <ProductsStepShell {...props} /> </Activity>,
  repository: useProductsStepRepository,
},
{
  id: STEP_PATHS.TARGETING,
  view: props => <Activity name={STEP_PATHS.TARGETING}> <TargetingStepShell {...props} /> </Activity>,
  repository: useTargetingStepRepository,
},
{
  id: STEP_PATHS.CAMPAIGNDETAILS,
  view: props => <Activity name={STEP_PATHS.CAMPAIGNDETAILS}> <CampaignDetailsStepShell {...props} /> </Activity>,
  repository: useCampaignDetailsStepRepository,
},
{
  id: STEP_PATHS.BUDGET,
  view: props => <Activity name={STEP_PATHS.BUDGET}> <BudgetStepShell {...props} /> </Activity>,
  repository: useBudgetStepRepository,
},
{
  id: STEP_PATHS.SUMMARY,
  view: props => <Activity name={STEP_PATHS.SUMMARY}> <SummaryStepShell {...props} /> </Activity>,
  repository: useSummaryStepRepository,
}];


export const getStepListConfig = ({ i18n, flow }) => {
  const stepListConfig = [{
    id: STEP_PATHS.ASSETS,
    title: i18n.getString(_TL_('Assets')),
  }, {
    id: STEP_PATHS.TARGETING,
    title: i18n.getString(_TL_('Targeting')),
  }, {
    id: STEP_PATHS.CAMPAIGNDETAILS,
    title: i18n.getString(_TL_('Campaign details')),
  }, {
    id: STEP_PATHS.BUDGET,
    title: i18n.getString(_TL_('Budget')),
  }, {
    id: STEP_PATHS.SUMMARY,
    title: i18n.getString(_TL_('Summary')),
  }];

  if (flow === FLOWS.RETAIL_PERF_MAX) {
    // add products step to the first
    stepListConfig.unshift({
      id: STEP_PATHS.PRODUCTS,
      title: i18n.getString(_TL_('Products')),
    });
  }

  return stepListConfig;
};
